module.exports = __webpack_public_path__ + "static/media/CTLA_1-96w.4deeb74c.webp";